import React, { ReactNode } from 'react';
import { Modal, ModalVariant } from 'fronton-react';
import { css } from 'linaria';

type ModalContainerProps = {
	isOpen: boolean;
	variant?: ModalVariant;
	onClose: () => void;
	children: ReactNode;
};

const ModalStyles = css`
	max-width: max-content !important;
`;

export const ModalContainer = ({
	isOpen,
	onClose,
	variant = 'full-screen',
	children,
}: ModalContainerProps) => (
	<Modal
		modalID="modal"
		className={variant === 'curtain' ? ModalStyles : ''}
		variant={variant}
		onClose={onClose}
		show={isOpen}
	>
		{children}
	</Modal>
);
